import Benefits from './Benefits.vue'

export default Benefits
